import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { ApplicationService } from 'src/app/core/services/application.services';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-evaluator-scan-result',
  templateUrl: './evaluator-scan-result.component.html',
  styleUrls: ['./evaluator-scan-result.component.scss']
})
export class EvaluatorScanResultComponent implements OnInit {
  applicationDetails
  applicantDetails
  pdfSrc
  isLoading: boolean = false
  constructor(private route: ActivatedRoute,
    private applicationService: ApplicationService,
    private evaluatorService: EvaluatorService,
    private httpClient: HttpClient,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.pdfSrc = '../../../../assets/documents/seminarcert.pdf'
    this.fetchFile(this.pdfSrc, "seminar.pdf")
      .then(file => this.pdfSrc = file);

    const applicationId = this.route.snapshot.paramMap.get("id");
    this.applicationService.getApplicationDetails(applicationId).pipe(take(1)).subscribe(res => {
      this.applicationDetails = res.data
      this.userService.getApplicantDetails(res.data.applicantId).pipe(take(1)).subscribe(res => {
        this.applicantDetails = res

      })
    })
  }

  handleAttendance() {
    Swal.fire({
      title:
        "Are you sure you want to mark as Attended?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      this.isLoading = true
      if (result.isConfirmed) {
        const body = {
          applicationId: this.applicationDetails.id,
          timeslotId: this.applicationDetails.seminarSchedules[0].timeslotId,
          isAttended: true
        }
        this.evaluatorService.updateAttendance(body).subscribe(res => {
          this.isLoading = false
          window.location.reload()
        })
      } else if (result.isDenied) {
        this.isLoading = false
        return
      }
    });
  }

  private async fetchFile(path: string, filename): Promise<File> {
    try {
      const response = await this.httpClient.get(path, { responseType: 'blob' }).toPromise();
      return new File([response], filename, { type: 'application/pdf' });
    } catch (error) {
      console.error('Error fetching file:', error);
      return null;
    }
  }
}
